import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { A11yModule } from '@angular/cdk/a11y';
import { WorkspaceComponent } from './workspace.component';
import { WorkspaceService } from './workspace.service';
import { DataFiltersComponent } from './data-filters/data-filters.component';
import { DataFiltersService } from './data-filters/data-filters.service';
import { GridImportToolbarComponent } from './grid-import-toolbar/grid-import-toolbar.component';
import { ImportUploadDialogComponent } from './grid-import-toolbar/import-upload-dialog.component';
import { ImportPasteDialogComponent } from './grid-import-toolbar/import-paste-dialog.component';
import { BatchProcessListDialogComponent } from './grid-import-toolbar/batch-process-list-dialog.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SubmissionListFilterComponent } from '../efile/submission-list-filter/submission-list-filter.component';

@NgModule({ declarations: [
        WorkspaceComponent,
        DataFiltersComponent,
        GridImportToolbarComponent,
        ImportUploadDialogComponent,
        ImportPasteDialogComponent,
        BatchProcessListDialogComponent,
        SubmissionListFilterComponent],
    exports: [WorkspaceComponent], imports: [CommonModule, FormsModule, RouterModule, MatDialogModule, A11yModule, SharedComponentsModule], providers: [WorkspaceService, DataFiltersService] })
export class WorkspaceModule {}
